package com.example.mystybag.login.model

data class StaffChangePasswordUIState(
    val newPassword: String = "",
    val newPasswordErrorMsg: String = "",
    val newPasswordIsError: Boolean = false,
    val newPasswordVisible: Boolean = false,
    val confirmPassword: String = "",
    val confirmPasswordErrorMsg: String = "",
    val confirmPasswordIsError: Boolean = false,
    val confirmPasswordVisible: Boolean = false,
    val passwordRequirements: PasswordRequirements = PasswordRequirements(),
    val isLoading: Boolean = false
)
